import ApiService from '@/services/api.service'

export default class RulesService {
  userGroups = null
  importerType = null
  repairRule = null

  async setRepairRule(rule = null) {
    if (rule === null) {
      try {
        const response = await ApiService.get('points-repair-rule')
        if (response.status === 200) {
          this.repairRule = response.data
        }
      } catch (error) {
        return null
      }
    } else {
      this.repairRule = rule
    }
  }

  setUserGroups(userGroups) {
    this.userGroups = userGroups
  }

  setImporterType(importerType) {
    this.importerType = importerType
  }

  addPointSettings(user) {
    user.volumes.forEach((pointData) => {
      if (pointData.repair_item !== undefined && pointData.repair_item === true) {
        pointData.pointSetting = this.repairRule
      } else {
        pointData.pointSetting = this.findMatchingRule(pointData)
      }
    })

    return user
  }

  findMatchingRule(pointData) {
    const rule = this.importerType.rules.find((rule) => {
      let foundRule = rule.items.every((item) => {
        const filterParts = item.filter.split('.')
        let valueToCheck = pointData

        filterParts.forEach((part) => {
          valueToCheck = valueToCheck ? valueToCheck[part] : null
        })

        valueToCheck ??= ''

        const value = (item.value ?? '') !== '' ? item.value : item.values
        let checkCondition = this.checkCondition(valueToCheck, item.operator, value)

        return checkCondition
      })

      return foundRule
    })

    return rule
  }

  checkCondition(valueToCheck, operator, value) {
    switch (operator) {
      case '=':
        return valueToCheck == value
      case '!=':
        return valueToCheck != value
      case '>':
        return valueToCheck > value
      case '>=':
        return valueToCheck >= value
      case '<':
        return valueToCheck < value
      case '<=':
        return valueToCheck <= value
      case 'contains':
        if (Array.isArray(valueToCheck)) {
          return Object.values(valueToCheck).map(String).includes(value)
        }
        return valueToCheck.indexOf(value) !== -1
      case 'containsNot':
        if (Array.isArray(valueToCheck)) {
          return !Object.values(valueToCheck).map(String).includes(value)
        }
        return valueToCheck.indexOf(value) === -1
      case 'match':
        return new RegExp(value).test(valueToCheck)
      case 'matchNot':
        return !new RegExp(value).test(valueToCheck)
      case 'oneOf':
        return value.includes(valueToCheck)
      case 'noneOf':
        return !value.includes(valueToCheck)
      default:
        return false
    }
  }
}
